import { combineReducers } from 'redux';

import data from './data';
import ui from './ui';

/**
 * @typedef {{
 *  data : import('./data').StatisticsDataReducer,
 *  ui: import('./ui').StatisticsUIReducer
 * }} StatisticsReducer
 */

export default combineReducers({
  ui,
  data,
});
